const CardShimmer = () => {
  return (
    <div className="w-48 py-14 md:w-64  bg-[#273c62] rounded-lg md:py-20 animate-pulse"></div>
  );
};

export default CardShimmer;
